import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  blockTitle: {
    id: 'FAQ',
    defaultMessage: 'FAQ',
  },
  contentFieldset: {
    id: 'Content',
    defaultMessage: 'Content',
  },
  items: {
    id: 'Questions',
    defaultMessage: 'Questions',
  },
  item: {
    id: 'Question',
    defaultMessage: 'Question',
  },
  question: {
    id: 'Question text',
    defaultMessage: 'Question text',
  },
  answer: {
    id: 'Answer',
    defaultMessage: 'Answer',
  },
});

/**
 * Item do acordeão. A resposta é `richtext` (HtmlSlateWidget do volto-slate,
 * registrado em core/packages/volto-slate/src/index.js) e não `textarea`
 * porque as respostas reais do FAQ têm negrito, listas e vários parágrafos —
 * ver docs/specs/blocks/faq.md §2.
 */
export const FaqItemSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.item),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['question', 'answer'],
    },
  ],
  properties: {
    question: {
      title: intl.formatMessage(messages.question),
      type: 'string',
    },
    answer: {
      title: intl.formatMessage(messages.answer),
      widget: 'richtext',
    },
  },
  required: [],
});

/**
 * Schema do bloco FAQ.
 * Um bloco por tema do documento-fonte (7 temas, 43 perguntas) — ver
 * docs/specs/blocks/faq.md §1.
 */
const FaqSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['items'],
    },
  ],
  properties: {
    items: {
      title: intl.formatMessage(messages.items),
      widget: 'object_list',
      schema: FaqItemSchema({ intl }),
    },
  },
  required: [],
});

export default FaqSchema;
